import { Field } from '@datx/core';
import { JsonApiModel } from '../../core/jsonApi/jsonApiModel';

export class LearningSectionLayoutJsonModel extends JsonApiModel {
  public static override readonly type = 'learning-section-layouts';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public name!: string;

  @Field()
  public columns!: number;

  @Field()
  public percentageSplit!: number;
}
